import { useEffect } from 'react';
import styles from './custom-text-area.module.scss';
import { CustomTextAreaProps } from './custom-text-area.props';

export default function CustomTextArea(props: CustomTextAreaProps) {
  return (
    <textarea className={styles.customTextara} value={props.value ? props.value : ''} placeholder={props.placeHolder} onChange={(e) => { props.getText(e.target.value) }} disabled={props.disabled} style={props.style} onBlur={(e) => { if (props.onBlur) props.onBlur(e.target.value) }} />
  )
}
